
















































































/* Created- 11 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { PageContent, EnumDTO, LoadPageContent } from "../../../Models/Components.model";
import ContentSelector from "@/Ui-Components/Content/ContentSelectorDrag.vue";
import TocForm from "@/Ui-Components/Article/TOC/TocForm.vue";
import PageTurner from "@/Ui-Components/Issue/PageTurner.vue";
import { IssueModel, PageContent as PdfPageContent, ListItemDTO, SectionModel } from "../../../Generated/ParticaAPI";
import { PdfContentService, IPdfContentService } from "../../../BusinessServices/issuecontent";
import { IssueService, IIssueService } from "../../../BusinessServices/issue";
import { ISectionService, SectionService } from "../../../BusinessServices/section";
import SectionManager from "@/Views/Domain/Title/SectionManager.vue";
import { ITOCArticle, Article } from "../../../Models/ArticleModels/article";
import { eParticaAction, getActionName, ParticaEvent } from "../../../Models/ParticaEvent";
import { ButtonConfig, ButtonType } from "../../../Models/Buttons";
import { IMetadataService } from "../../../BusinessServices/metadataarticles";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaIssueBase from "../../Base/ParticaIssueBase.vue";

@Component(
	{
		name: "IssueTOC",
		components: {
			ParticaError,
			ParticaRowContainer,
			PageTurner,
			ContentSelector,
			TocForm,
			ButtonList,
			SectionManager,
			ParticaCard,
			ParticaView
		}
	})
export default class IssueTOC extends ParticaIssueBase {
	private TOCs: ITOCArticle[] = new Array<Article>() as ITOCArticle[];
	private TOC: ITOCArticle = new Article() as ITOCArticle;
	@Prop() private id: number;
	private issue: IssueModel | null = null;
	private pageNumber: number = 1;
	private content: PageContent | null = null;
	private sections: SectionModel[] = new Array<SectionModel>();
	private showsectionmanager: boolean = false;

	private pdfContentService: IPdfContentService;
	private issueService: IIssueService;
	private metadataService: IMetadataService;
	private sectionService: ISectionService;
	private width: number = 700;

	private buttons: ButtonConfig[] = [
		{ label: "Save", action: eParticaAction.ISSUE_SAVE_TOC, type: ButtonType.OK } as ButtonConfig,
		{ label: "Clear", action: eParticaAction.ISSUE_CLEAR_TOC, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Section Manager", action: eParticaAction.PUBLICATION_SECTION_MANAGER, type: ButtonType.Normal } as ButtonConfig,
	];

	private pageMetadata(): ButtonConfig[] {
		const pageButtons: ButtonConfig[] = [];
		this.TOCs.filter(item => item.pageNumber === this.pageNumber).forEach(item => {
			pageButtons.push({ label: item.title, action: item.id, type: ButtonType.Normal } as ButtonConfig);
		});
		return pageButtons;
	}

	private selectMetadata(event: ParticaEvent) {
		const found = this.TOCs.find(item => item.id === event.action);
		if (found === undefined) {
			this.ShowSnackbar("Item not found.");
		} else {
			this.TOC = found;
		}
	}

	@Watch("showsectionmanager")
	private async reloadsections() {
		if (this.showsectionmanager === false) {
			if (this.issue !== null && this.issue.publicationId !== undefined) {
				this.sections = await this.sectionService.getSections(this.issue.publicationId);
			}
		}
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {

				case eParticaAction.PUBLICATION_SECTION_MANAGER: {
					this.showsectionmanager = true;
					break;
				}
				case eParticaAction.LEFT_MOUSE_CLICK: {
					this.TOC.title += event.item.content;
					this.TOC.pageNumber = this.pageNumber;
					break;
				}
				case eParticaAction.RIGHT_MOUSE_CLICK: {
					this.TOC.abstract += event.item.content;
					break;
				}
				case eParticaAction.ISSUE_CLEAR_TOC: {
					const previousSectionId = this.TOC.sectionId;
					this.TOC = new Article() as ITOCArticle;
					this.TOC.sectionId = previousSectionId;
					this.TOC.pageNumber = this.pageNumber;
					break;
				}
				case eParticaAction.ARTICLE_SAVE:
				case eParticaAction.ISSUE_SAVE_TOC: {
					const previousSectionId = this.TOC.sectionId;
					let newTOC: boolean = false;
					if (this.TOC.id === 0) {
						newTOC = true;
					}
					this.TOC.issueId = this.id;
					const result: ITOCArticle = await this.metadataService.saveTOC(this.TOC);
					this.TOC = new Article() as ITOCArticle;
					this.TOC.sectionId = previousSectionId;
					this.TOC.pageNumber = this.pageNumber;
					if (newTOC === true) {
						this.TOCs.push(result);
					}
					break;
				}
				case eParticaAction.PAGE_CHANGE: {
					this.pageNumber = event.item as number;
					await this.loadPageContent(this.pageNumber);
					if (this.TOC.id === 0) {
						this.TOC.pageNumber = this.pageNumber;
					}
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.TOC.pageNumber = 1;
		this.metadata.name = "Create Table of Contents";
		this.pdfContentService = this.particaServices.getPdfContentService();
		this.issueService = this.particaServices.getIssueService();
		this.metadataService = this.particaServices.getMetadataService();
		this.sectionService = this.particaServices.getSectionService();
		await this.init();

	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getIssueNav(this.id);
			this.issue = await this.issueService.getIssue(this.id);
			this.TOCs = await this.metadataService.getTOCForIssue(this.id);
			if (this.issue.publicationId !== undefined) {
				this.sections = await this.sectionService.getSections(this.issue.publicationId);
			}
			await this.loadPageContent(this.pageNumber);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}

	private async loadPageContent(pageNumber: number) {
		try {
			this.LoadingStart();
			this.content = await this.pdfContentService.getPageContentInception(this.id, pageNumber, LoadPageContent.Text);
			if (this.issue != null) {
				this.content.src = `${this.stateconfig.thumburl}${this.issue.guid}/thumb/${this.pageNumber}.1200.jpg`;
			}
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
